import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faCalendar,faClock,faClone,faCompass,faEnvelope,faFile,faFloppyDisk,faHandshake, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faCalendarPlus, faNoteSticky, faPeopleGroup, faPeopleRoof } from '@fortawesome/free-solid-svg-icons';



const StatementCard = ({ data,datasource }) => {

//console.log(data)

  

  return (   
    

    <div className="statementcard ituCard"  data-span="4">
     
      <div className="statementcontent">
        <p className="statementtype">
          {data.MeetingType}
        </p>
        <p className="statementadminorg">
          {data.MonitorTitle}
        </p>


         <p style={{marginTop: '20px',color: '#6e6e6e', fontSize: '1rem' }}>
          <FontAwesomeIcon icon={faCalendar} />
          {/* adding space */}
          {'\u00A0'}{'\u00A0'}

          {data.DateSession}
        </p>


        {/** commitee only for daily schedule */}
        {datasource !== 'social_events' && datasource !== 'side_events' &&  data.MeetingGroup !==''?
        (
          <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>        
          <FontAwesomeIcon icon={faBookmark} />
          {/* adding space */}
          {'\u00A0'}{'\u00A0'} 
           {data.MeetingGroup}
          </p> 
        )
        : 
        null
        }

       
         {/**Time start and time end to only for social events*/}
         {(data.TimeSessionStartEnd!=='' || data.TimeSession !=='')?
        (
        <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>
        <FontAwesomeIcon icon={faClock} />
        {/* adding space */}
        {'\u00A0'}{'\u00A0'}
              
            {/** end time only for social events */}
          {datasource === 'social_events' ||  datasource === 'side_events' ?     
            data.TimeSessionStartEnd
          : 
          data.TimeSession
          }
          
          </p>
        )
        : 
        null
        }

          
        {(data.RoomName!=='')?
        (
        <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>       
        <FontAwesomeIcon icon={faCompass} /> 
        {/* adding space */}
        {'\u00A0'}{'\u00A0'}
          {data.RoomName} 
        </p>
        )
        : 
        null
        }


        {/**inviation to only for social events*/}
        {(datasource === 'social_events' || datasource === 'side_events') && (data.Message!=='')?
        (
          <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>        
          <FontAwesomeIcon icon={faEnvelope} />
          {/* adding space */}
          {'\u00A0'}{'\u00A0'} 
            {data.Message}
          </p> 
        )
        : 
        null
        }


        {/** agenda dms doc only for daily schedule */}
        {datasource !== 'social_events' &&  datasource !== 'side_events' &&  data.DocumentNumber !==''?
        (
          <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>  
           <a href={data.DocumentNumber} style={{textDecoration:'none'}}>     
            <FontAwesomeIcon icon={faCalendarPlus} />
            {/* adding space */}
            {'\u00A0'}{'\u00A0'} 
            Agenda
          </a>
          </p> 
        )
        : 
        null
        }


        {/**Notes only for social events*/}
        {/**(datasource === 'social_events' || datasource === 'side_events') && (data.Comments!=='') ?*/
        (datasource === 'social_events') && (data.Comments!=='') ?
        (
          <p style={{marginTop: '5px',color: '#6e6e6e', fontSize: '1rem' }}>        
          <FontAwesomeIcon icon={faNoteSticky} />
         
          {'\u00A0'}{'\u00A0'} 
            {data.Comments}
          </p> 
        )
        : 
        null
        
        }


        
      </div>
   
    </div>
  );
};

export default StatementCard;
